import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-053e6745"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Afprøv regler på Service Kontrakt")
  ])
], -1))
const _hoisted_2 = { class: "row mt-3" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "table table-sm table-striped table-responsive" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " Opgaver på kontrakten "),
    /*#__PURE__*/_createElementVNode("th", null, " Besøg Pr år ")
  ])
], -1))
const _hoisted_8 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Kalender")
  ])
], -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "table table-sm" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " År/Måned ", -1))
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { key: 0 }

import { API } from '@/helpers/API';
    import { ref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceTaskCalendar',
  setup(__props) {

    const engineRuleTestUrl = '/engine/test'
    const calendar = ref<Object>();
    const tasks = ref<any>([]);
    const serviceAgreementId = ref<number>(1018445)

    const monthsNames = ref<Object>({
        1: 'Januar',
        2: 'Februar',
        3: 'Marts',
        4: 'April',
        5: 'Maj',
        6: 'Juni',
        7: 'Juli',
        8: 'August',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    })

    const runTest = () => {
        const requestConfig = {
            url: engineRuleTestUrl,
            method: 'get',
            params: {
                ServiceAgreementID: serviceAgreementId.value
            }
        };
        API.request(requestConfig)
        .then((response) => {
            calendar.value = response.data.calendar;
            console.log(calendar.value);
            tasks.value = response.data.tasks;
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const cellDisabled = (value: boolean) => {
        return value ? 'bg-white' : 'bg-secondary';
    }

    const visitType = (month: any) => {
        let type = '';
        if (month.startup) {
            type = '4_OPSTART';
        }
        else if (month.takedown) {
            type = '5_HJEMTAG';
        } else {
            type = '1_SERVICE';
        }

        if (month.singleTasks.length > 0) {
            type += ' + 1_Service'
        }

        return type;
    }

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" Service Aftale ID "),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "serviceAgreementId",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serviceAgreementId).value = $event))
        }, null, 512), [
          [_vModelText, serviceAgreementId.value]
        ]),
        _createTextVNode(),
        _createElementVNode("button", { onClick: runTest }, "Kør test")
      ])
    ]),
    (tasks.value && tasks.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task, taskIndex) => {
                  return (_openBlock(), _createElementBlock("tr", { key: taskIndex }, [
                    _createElementVNode("td", null, _toDisplayString(task.Description), 1),
                    _createElementVNode("td", null, _toDisplayString(task.VisitsPerYear), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (calendar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_14,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthsNames.value, (month, monthIndex) => {
                        return (_openBlock(), _createElementBlock("th", { key: monthIndex }, _toDisplayString(month), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendar.value, (months, year) => {
                      return (_openBlock(), _createElementBlock("tr", { key: year }, [
                        _createElementVNode("td", _hoisted_15, _toDisplayString(year), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthsNames.value, (month, monthIndex) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: monthIndex,
                            class: _normalizeClass(cellDisabled(months[monthIndex]))
                          }, [
                            (months[monthIndex] && months[monthIndex] && months[monthIndex].combinedTasks.length > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(visitType(months[monthIndex])), 1))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})